import { ProductModule } from '@erp/shared-types';
import { useGetModuleConfigs } from './modules';

/** Modules whose synced sales orders populate an Oracle-side order number. */
const ORACLE_ERP_INTEGRATION_MODULES: ReadonlyArray<ProductModule> = [
  ProductModule.ORACLE_EBS_INTEGRATION,
  ProductModule.ORACLE_FUSION_INTEGRATION,
];

/**
 * Hook to check if the organization has an Oracle ERP sales-order integration
 * configured (Oracle EBS or Oracle Fusion).
 *
 * Used for UI that is Oracle-specific — e.g. the "Oracle Order #" column on
 * sales-order list tables. Famous-integrated orgs use a different ERP and
 * already surface their order ID elsewhere (e.g. under Stage / as "Famous
 * Order ID" on the detail view).
 */
export function useHasOracleErpIntegration() {
  const { data: moduleConfigs, isLoading } = useGetModuleConfigs();

  const hasOracleErpIntegration =
    moduleConfigs?.some(
      (config) =>
        ORACLE_ERP_INTEGRATION_MODULES.includes(config.module) &&
        config.enabled,
    ) ?? false;

  return { hasOracleErpIntegration, isLoading };
}
